import React from "react";
import { Container } from "react-bootstrap";

const About = () => {
  return (
    <>
      <Container className="abt">
        <h2>
          <b>
            About <span>Us</span>
          </b>
        </h2>
        <p>
          <b className="fs-5">Welcome to Super Mall!</b> <br />
          Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat. Eu tincidunt tortor aliquam nulla
          facilisi cras. Tellus elementum sagittis vitae et. Rhoncus urna neque
          viverra justo nec ultrices. Lacus luctus accumsan tortor posuere.
          Mattis enim ut tellus elementum sagittis vitae et leo duis. Elementum
          nisi quis eleifend quam adipiscing vitae. Phasellus egestas tellus
          rutrum tellus pellentesque eu tincidunt.
        </p>
        <p>
          &hearts; Our mission is to provide high-quality products/services and
          ensure customer satisfaction. We are passionate about what we do and
          strive to exceed our customers' expectations.
          <br />
          <br /> Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Elementum
          nisi quis eleifend quam adipiscing vitae. Phasellus egestas tellus
          rutrum tellus pellentesque eu tincidunt. Eu tincidunt tortor aliquam
          nulla facilisi cras. Tellus elementum sagittis vitae et. Rhoncus urna
          neque viverra justo nec ultrices. Lacus luctus accumsan tortor
          posuere. Mattis enim ut tellus elementum sagittis vitae et leo duis.
          Praesent tristique magna sit amet purus gravida quis blandit. Interdum
          posuere lorem ipsum dolor sit. Consequat semper viverra nam libero
          justo laoreet sit. Lorem ipsum dolor sit amet, consectetur adipiscing
          elit, sed do eiusmod tempor incididunt ut labore et dolore magna
          aliqua. Quisque egestas diam in arcu cursus euismod quis. Lorem ipsum
          dolor sit amet consectetur adipiscing elit duis tristique. In ornare
          quam viverra orci sagittis eu volutpat odio facilisis. Ante in nibh
          mauris cursus mattis molestie a iaculis. Magna sit amet purus gravida
          quis blandit. Ultricies mi eget mauris pharetra et ultrices neque
          ornare. Integer malesuada nunc vel risus commodo viverra. Sed
          elementum tempus egestas sed sed. Neque laoreet suspendisse interdum
          consectetur libero id. Amet cursus sit amet dictum sit amet justo.
          Posuere lorem ipsum dolor sit. Tristique sollicitudin nibh sit amet.
          Vitae justo eget magna fermentum.
        </p>
        <p>
          <i>
            Thank you for choosing us. If you have any questions or feedback,
            feel free to contact us.
          </i>
        </p>
      </Container>
    </>
  );
};

export default About;
